const getGeolicalizedLabel = (poligono, centroide) => {
  if (poligono == 1) return 'polígono';
  if (centroide == 1) return 'centroide';
  return 'sin geolocalizar';
};

export default getGeolicalizedLabel;
